var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 120 120",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF97B7;}\r\n\t.st1{fill:#FFC54D;}\r\n\t.st2{fill:#E8B04B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.7,58.3 60,66.2 44.3,58.3 24.9,97.1 37,95.9 43.2,106.3 60,72.9 76.8,106.3 83,95.9 95.1,97.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.8,38.2l-1.1,4.2c-0.3,1.4-0.1,2.9,0.6,4.2l2.1,3.8c1.3,2.2,0.9,5.1-1.1,6.9l-3.2,2.9   c-1.1,1-1.7,2.4-1.8,3.8l-0.2,4.3c-0.2,2.6-2,4.8-4.6,5.2l-4.3,0.8c-1.4,0.3-2.7,1.1-3.6,2.2L73.1,80c-1.5,2.1-4.3,2.9-6.6,1.9   l-4-1.7c-1.4-0.6-2.8-0.6-4.2,0l-4.1,1.6c-2.4,0.9-5.2,0.1-6.7-2L45,76.1c-0.8-1.2-2.1-2-3.5-2.3L37.3,73c-2.6-0.5-4.4-2.7-4.5-5.3   l-0.2-4.4c0-1.5-0.6-2.8-1.7-3.8l-3.2-3c-1.9-1.8-2.3-4.6-0.9-6.9l2.3-3.8c0.8-1.2,1-2.7,0.6-4.1l-1-4.3c-0.6-2.5,0.6-5.1,2.9-6.3   l3.9-1.9c1.3-0.6,2.3-1.8,2.8-3.1l1.4-4.2c0.9-2.4,3.3-4,5.9-3.7l4.4,0.4c1.4,0.2,2.9-0.2,4.1-1.2l3.4-2.7c2-1.6,4.9-1.6,6.9,0.1   l3.4,2.7c1.2,0.9,2.6,1.4,4,1.2l4.3-0.4c2.6-0.3,5,1.3,5.8,3.8l1.3,4.1c0.4,1.4,1.5,2.6,2.8,3.2l3.9,2   C92.2,33.1,93.5,35.7,92.8,38.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 60,
    cy: 48.6,
    r: 25.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.b92d9448311a47f06e6c105deed500bf.svg";
export { ForwardRef as ReactComponent };